interface LoadingErrorProps {
  error?: any
}

export function LoadingError({ error }: LoadingErrorProps) {
  return (
    <div className="h-screen flex items-center justify-center scale-300">
      <div>
        Failed to load...
      </div>
      {error && (
        <span>{error}</span>
      )}
    </div>
  );
};
